import markerIconUrl from '../../../assets/icons/marker.svg';
import { Category } from '../../../queries/categoriesQuery';
import { Marker } from '../../../queries/markersQuery';
import { customMarker } from '../customMarker';

export const createMapMarkers = (
  markers: Marker[],
  currentCategory: Category,
  map?: google.maps.Map | google.maps.StreetViewPanorama
) => {
  const infoWindow = new google.maps.InfoWindow();

  const mapMarkers = markers.map(item => {
    const marker = new google.maps.Marker({
      position: item.location,
      icon: {
        url: customMarker(currentCategory.color),
      },
    });

    const html = `
      <div class="InfoWindow__header">
        <img src=${markerIconUrl}></img>
        <h2 class="InfoWindow__location">${item.address}</h2>
      </div>
      ${item.branches
        .map(
          branch => `   <div class="InfoWindow__branch">
                          <h3>${branch.name}</h3>
                          <p>${branch.description}</p>
                        </div>
                      `
        )
        .join('')}
    `;

    marker.addListener('click', () => {
      infoWindow.setPosition({ lat: item.location.lat, lng: item.location.lng });
      infoWindow.setContent(html);
      infoWindow.open({ map });
    });

    return marker;
  });

  return mapMarkers;
};
